import moment from 'moment';
import { aggloSlots } from './utils';

/**
 * Date the funnel will book, derived from the slots picked in RepairDate.
 *
 * Single source for the `date` field of the POST /courses payload AND for the
 * `date` query param of GET /clients/{client}/courses/overlapping (FIX-94):
 * asking the api about a different day than the one we are about to book would
 * silently answer the wrong question.
 *
 * @param {Array} slots raw course slots ({ available_min, available_max })
 * @returns {string|null} `YYYY-MM-DD HH:mm:00`, or null when undecidable
 */
export default function buildCourseDate(slots) {
  if (!slots || slots.length === 0) return null;

  const agglomerated = aggloSlots(slots);
  const days = Object.keys(agglomerated);
  if (days.length === 0) return null;

  const daySlots = agglomerated[days[0]];
  if (!daySlots || daySlots.length === 0) return null;

  const day = moment(days[0]);
  if (!day.isValid()) return null;

  return day.format(`YYYY-MM-DD ${daySlots[0].min}:00`);
}

/**
 * Day part of a booked date, `YYYY-MM-DD`.
 *
 * What GET /clients/{client}/courses/overlapping expects as its `date` query
 * param (FIX-94). Only the day is significant to the api rule (it compares
 * `DATE(...) >= DATE(...)`), and the api validates the format strictly — a
 * shape it does not accept answers 422, which the front reads as "no overlap",
 * so the whole feature would go quietly dead. Derived from the very string
 * that goes into the POST /courses payload, so the two cannot drift.
 *
 * @param {?string} courseDate `YYYY-MM-DD HH:mm:ss` from buildCourseDate
 * @returns {string|null} `YYYY-MM-DD`
 */
export function toCourseDay(courseDate) {
  if (!courseDate) return null;

  const day = courseDate.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : null;
}
